import { AppDateInput } from "@/components/forms"
import type { TQuestionProps } from "./types"

export function QuestionDate({ value, setValue, preview, question }: TQuestionProps) {
  if (preview && !value) value = Date.now() / 1000
  let defaultDate = new Date()
  if (question.type == "personal") {
    defaultDate = question.meta.category == "birthday" ? new Date("2000-01-01") : new Date("2015-01-01")
  }

  return (
    <AppDateInput
      size="md"
      maw={400}
      value={value ? value * 1000 : null}
      clearable={!preview}
      disabled={preview}
      resultFormat="number"
      onChange={(value) => setValue(value ? value / 1000 : null)}
      defaultDate={defaultDate}
    />
  )
}
